module.exports = __webpack_public_path__ + "static/media/LOGO_CHU_UL_RVB_110x112.eb134f75.jpg";